import * as React from 'react';
import {isObservableArray, isObservableObject, ObservableMap, IObservableObject} from 'mobx';

export interface TextTypeRow {
    type: "row";
    value: TextStruct[];
}

type TextTypeColumnSize = 'xs1' | 'xs2' | 'xs3' | 'xs4' | 'xs5' | 'xs6' | 'xs7' | 'xs8' | 'xs9' | 'xs10' | 'xs11' | 'xs12'
    | 'sm1' | 'sm2' | 'sm3' | 'sm4' | 'sm5' | 'sm6' | 'sm7' | 'sm8' | 'sm9' | 'sm10' | 'sm11' | 'sm12'
    | 'md1' | 'md2' | 'md3' | 'md4' | 'md5' | 'md6' | 'md7' | 'md8' | 'md9' | 'md10' | 'md11' | 'md12'
    | 'lg1' | 'lg2' | 'lg3' | 'lg4' | 'lg5' | 'lg6' | 'lg7' | 'lg8' | 'lg9' | 'lg10' | 'lg11' | 'lg12';

export interface TextTypeColumn {
    type: "column";
    value: TextStruct[];
    size: Array<TextTypeColumnSize>;
}

export interface TextTypeP {
    type: "p";
    value: string;
}

export interface TextTypeH {
    type: "h1" | "h2" | "h3" | "h4" | "h5";
    value: string;
}

export interface TextTypeList {
    type: "list";
    value:  TextStruct[];
}

export interface TextTypeLink {
    type: "link";
    value: string;
    link: string;
    title: string;
    target: '_blank' | '_self';
}

export interface TextTypeImage {
    type: "image";
    value: string;
    title?: string;
    style?: Object;
}

export interface TextTypeText {
    type: "line" | "span" | "inline" | "b";
    value: string;
}

/**
 * @TODO    Change this Union Types to Tagged when WS added support of it
 *          https://www.typescriptlang.org/docs/release-notes/typescript-2.0.html
 */
export type TextStruct = string | TextTypeText | TextTypeImage | TextTypeH | TextTypeP | TextTypeRow | TextTypeColumn | TextTypeList | TextTypeLink;

export interface DrawTextProps {
    data: TextStruct[];
}

export class DrawText extends React.Component<DrawTextProps, any> {
    private uniqueId = 0;
    private getUniqueId(): string {
        this.uniqueId++;
        return "unique_id_" + this.uniqueId.toString();
    }
    
    private drawItem(item: TextStruct): any {
        if (typeof item === 'string') {
            return item;
        } else if (isObservableArray(item)) {
            return item.map(x => this.drawItem(x));
        }
        
        switch (item.type) {
            case 'row':
                return (
                    <div className="row" key={this.getUniqueId()}>
                        {item.value.map((x, j) => this.drawItem(x as TextStruct))}
                    </div>
                );
                
            case 'column':
                return (
                    <div className={item.size && item.size.map(x => x.replace(/^(.+)(\d+)$/, 'col-$1-$2')).join(' ')} key={this.getUniqueId()}>
                        {item.value.map((x, j) => this.drawItem(x as TextStruct))}
                    </div>
                );
                
            case 'image':
                return (
                    <div className="type-image" key={this.getUniqueId()}>
                        {item.title ? <span>{this.drawItem(item.value)}</span> : ''}
                        <img style={item.style || {}} src={item.value} className="img-responsive" />
                    </div>
                );
                
            case 'h1':
                return <h1 key={this.getUniqueId()}>{this.drawItem(item.value)}</h1>;
                
            case 'h2':
                return <h2 key={this.getUniqueId()}>{this.drawItem(item.value)}</h2>;
                
            case 'h3':
                return <h3 key={this.getUniqueId()}>{this.drawItem(item.value)}</h3>;
                
            case 'h4':
                return <h4 key={this.getUniqueId()}>{this.drawItem(item.value)}</h4>;
                
            case 'h5':
                return <h5 key={this.getUniqueId()}>{this.drawItem(item.value)}</h5>;
            
            case 'link':
                return <a key={this.getUniqueId()} href={item.link} target={item.target} title={item.title}>{item.value}</a>;
                
            case 'list':
                return (
                    <ul key={this.getUniqueId()}>
                        {item.value.map((value, i) => <li key={this.getUniqueId()}>{this.drawItem(value)}</li>)}
                    </ul>
                );
    
            case 'line':
                return <span key={this.getUniqueId()}>{item.value}<br/></span>;
    
            case 'inline':
                return <span key={this.getUniqueId()}>{item.value}</span>;
    
            case 'b':
                return <b key={this.getUniqueId()}>{item.value}</b>;
    
            case 'p':
                return <p className="type-p" key={this.getUniqueId()}>{this.drawItem(item.value)}</p>;
                
            default:
                return ['line', 'inline', 'b']
                    .filter(key => item[key])
                    .map(key => this.drawItem({type: key, value: item[key]} as TextStruct));
        }
    }
    
    render() {
        return (
            <div className="text">
                {this.props.data.map(item => this.drawItem(item))}
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/DrawText.tsx
 **/